// @flow

// Effect Managers
import { call } from 'redux-saga/effects'

// Types
import type { ImportJobsToolOperation } from '../../types'

// Utils
import { validateModel } from 'hfty-model-import-jobs-tool'

export default function *validateOperationSaga (operation: ImportJobsToolOperation): Generator<*, *, *> {
  const errors = yield call(validateModel, operation.model)

  const nextOperation = {
    ...operation,
    submitting: false,
    errors: [
      ...operation.errors,
      ...errors,
    ],
  }

  return nextOperation
}
